<app-master-data-table [data]="masterCommonService.deliveredTosList" [columns]="deliveredtoColumns"
  title="Delivered To List" addButtonLabel="Delivered To" (add)="openAddUpdateDeliveredToDialog('add')"
  (update)="openAddUpdateDeliveredToDialog('update', $event)" (delete)="deleteDeliveredTo($event)">
</app-master-data-table>